import api from '~/services/api';
import { IThunkDisableEdits } from '../types';
import { thunk } from 'easy-peasy';

const onDisableEdits: IThunkDisableEdits = thunk(async (_, { clinicId, data }) => {
  await api.clinic.disableClinicEdits(clinicId, data);
});

export default onDisableEdits;
